
function BarsSVG() {
  return (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 15.7576H20V13.1311H0V15.7576ZM0 9.19171H20V6.56586H0V9.19171ZM0 0V2.62647H20V0H0Z" fill="#A0A0A0"/>
    </svg>
  )
}

export { BarsSVG }